/* ============================================
   HERBAL DATABASE (~100 herbs)
============================================ */

window.herbDatabase = {

hawthorn:{name:"Hawthorn",taste:"tart",role:"primary",actions:["circulation","heart"]},
hibiscus:{name:"Hibiscus",taste:"tart",role:"support",actions:["circulation"]},
garlic:{name:"Garlic",taste:"pungent",role:"support",actions:["circulation"]},
ginger:{name:"Ginger",taste:"warming",role:"enhancer",actions:["digestion","circulation","inflammation"]},
turmeric:{name:"Turmeric",taste:"bitter",role:"support",actions:["inflammation"]},
licorice:{name:"Licorice Root",taste:"sweet",role:"balancer",actions:["flavor","adrenal"],contra:["high_blood_pressure"]},

elderberry:{name:"Elderberry",taste:"tart",role:"primary",actions:["immune"]},
echinacea:{name:"Echinacea",taste:"bitter",role:"support",actions:["immune"]},
astragalus:{name:"Astragalus",taste:"sweet",role:"support",actions:["immune"]},

ashwagandha:{name:"Ashwagandha",taste:"bitter",role:"primary",actions:["stress","adaptogen"]},
rhodiola:{name:"Rhodiola",taste:"bitter",role:"support",actions:["energy","adaptogen"]},
holy_basil:{name:"Holy Basil",taste:"aromatic",role:"support",actions:["stress"]},
lemon_balm:{name:"Lemon Balm",taste:"aromatic",role:"support",actions:["stress","sleep"]},
skullcap:{name:"Skullcap",taste:"bitter",role:"support",actions:["sleep"]},
passionflower:{name:"Passionflower",taste:"bitter",role:"support",actions:["sleep"]},
valerian:{name:"Valerian",taste:"bitter",role:"primary",actions:["sleep"]},
chamomile:{name:"Chamomile",taste:"aromatic",role:"support",actions:["sleep","digestion"]},

peppermint:{name:"Peppermint",taste:"cooling",role:"support",actions:["digestion"]},
fennel:{name:"Fennel",taste:"sweet",role:"support",actions:["digestion"]},
gentian:{name:"Gentian",taste:"bitter",role:"primary",actions:["digestion"]},
dandelion:{name:"Dandelion Root",taste:"bitter",role:"support",actions:["liver"]},
burdock:{name:"Burdock",taste:"bitter",role:"support",actions:["liver"]},
milk_thistle:{name:"Milk Thistle",taste:"bitter",role:"primary",actions:["liver"]},

nettle:{name:"Nettle",taste:"green",role:"support",actions:["nutrition"]},
red_clover:{name:"Red Clover",taste:"sweet",role:"support",actions:["detox"]},
yarrow:{name:"Yarrow",taste:"bitter",role:"support",actions:["circulation"]},

mullein:{name:"Mullein",taste:"mild",role:"primary",actions:["respiratory"]},
thyme:{name:"Thyme",taste:"aromatic",role:"support",actions:["respiratory"]},
oregano:{name:"Oregano",taste:"pungent",role:"support",actions:["immune"]},

marshmallow_root:{name:"Marshmallow Root",taste:"sweet",role:"support",actions:["respiratory"]},
slippery_elm:{name:"Slippery Elm",taste:"sweet",role:"support",actions:["digestion"]},

catnip:{name:"Catnip",taste:"aromatic",role:"support",actions:["digestion"]},

boswellia:{name:"Boswellia",taste:"bitter",role:"support",actions:["inflammation"]},
willow_bark:{name:"Willow Bark",taste:"bitter",role:"support",actions:["pain"]},

ginkgo:{name:"Ginkgo",taste:"bitter",role:"support",actions:["circulation"],contra:["blood_thinners"]},
st_johns_wort:{name:"St Johns Wort",taste:"bitter",role:"support",actions:["mood"],contra:["antidepressants"]},

cinnamon:{name:"Cinnamon",taste:"sweet",role:"balancer",actions:["warming"]},

cardamom:{name:"Cardamom",taste:"aromatic",role:"balancer",actions:["digestion"]},

clove:{name:"Clove",taste:"pungent",role:"balancer",actions:["warming"]}

};